/* eslint-disable no-case-declarations */
import {
  ActionReducer,
  ActionReducerMap,
  MetaReducer,
  INIT
} from "@ngrx/store";
import * as fromAdministration from "./administration/administration.reducer";
import { AdministrationActions } from "./administration/administration.actions";
import { AdministrationEffects } from "./administration/administration.effects";
import * as fromScenario from "./scenario/scenario.reducer";
import { ScenarioEffects } from "./scenario/scenario.effects";
import * as fromLegalEntities from "./legal-entities/legal-entities.reducer";
import { LegalEntitiesEffects } from "./legal-entities/legal-entities.effects";
import * as fromCpt from "./cpt/cpt.reducer";
import { CptEffects } from "./cpt/cpt.effects";
import * as fromUsers from "./users/users.feature";
import * as fromRisks from "./risk/risk.reducer";
import * as fromQualitative from "./qualitative/qualitative.reducer";
import { UserEffects } from "./users/users.effects";
import { RiskEffects } from "./risk/risk.effects";
import { QualitativeEffects } from "./qualitative/qualitative.effects";
import * as fromRiskMap from './risk-map/risk-map.reducer';
import { RiskMapEffects } from "./risk-map/risk-map.effects";
import * as fromDataMonitoring from './data-monitoring/data-monitoring.reducer';
import { DataMonitoringEffects } from "./data-monitoring/data-monitoring.effects";
import * as fromEvaluation from './evaluation/evaluation.reducer';
import { EvaluationEffects } from "./evaluation/evaluation.effects";
import * as fromRelevance from './relevance/relevance.reducer';
import { RelevanceEffects } from "./relevance/relevance.effects";
import * as fromQualitativeInput from './qualitative-input/qualitative-input.reducer';
import { QualitativeInputEffects } from "./qualitative-input/qualitative-input.effects";
import * as fromBaselineCheck from './baseline-check/baseline-check.reducer';
import { BaselineCheckEffects } from "./baseline-check/baseline-check.effects";
import * as fromHeatmap from './heatmap/heatmap.reducer';
import * as fromThreshold from './threshold/threshold.reducer';
import { HeatmapEffects } from "./heatmap/heatmap.effects";
import { ThresholdEffects } from "./threshold/threshold.effects";
import * as fromStandardRiskmap from './standard-riskmap/standard-riskmap.reducer';
import { StandardRiskmapEffects } from "./standard-riskmap/standard-riskmap.effects";
import * as fromRiskmaptree from './riskmaptree/riskmaptree.reducer';
import { RiskmaptreeEffects } from "./riskmaptree/riskmaptree.effects";
import * as fromRiskMapProcessFeatureKey from './qualitative-input-tree/qualitative-input-tree.reducer';
import { QualitativeInputTreeEffects } from "./qualitative-input-tree/qualitative-input-tree.effects";
import * as fromEvaluationTree from './evaluation-tree/evaluation-tree.reducer';
import { EvaluationTreeEffects } from "./evaluation-tree/evaluation-tree.effects";
import * as fromRelevanceTree from './relevance-tree/relevance-tree.reducer';
import { RelevanceTreeEffects } from "./relevance-tree/relevance-tree.effects";
import * as fromBaselineCheckTree from './baseline-check-tree/baseline-check-tree.reducer';
import { BaselineCheckTreeEffects } from "./baseline-check-tree/baseline-check-tree.effects";
import * as fromStandardRelevance from './standard-relevance/standard-relevance.reducer';
import { StandardRelevanceEffects } from "./standard-relevance/standard-relevance.effects";
import * as fromCampaignDashboard from './campaign-dashboard/campaign-dashboard.reducer';
import { CampaignDashboardEffects } from "./campaign-dashboard/campaign-dashboard.effects";
import * as fromIcsAttestation from './ics-attestation/ics-attestation.reducer';
import { IcsAttestationEffects } from "./ics-attestation/ics-attestation.effects";
import * as fromManageCampaign from './manage-campaign/manage-campaign.reducer';
import { ManageCampaignEffects } from "./manage-campaign/manage-campaign.effects";
import * as fromIcsEvaluation from './ics-evaluation/ics-evaluation.reducer';
import { IcsEvaluationEffects } from "./ics-evaluation/ics-evaluation.effects";
import * as fromScenarioConfiguration from './scenario-configuration/scenario-configuration.reducer';
import { ScenarioConfigurationEffects } from "./scenario-configuration/scenario-configuration.effects";
import * as fromScenarioConsolidation from './scenario-consolidation/scenario-consolidation.reducer';
import { ScenarioConsolidationEffects } from "./scenario-consolidation/scenario-consolidation.effects";
import * as fromPlanning from './planning/planning.reducer';
import * as fromProcessRiskmap from './process-riskmap/process-riskmap.reducer';
import { ProcessRiskmapEffects } from "./process-riskmap/process-riskmap.effects";
import * as fromRiskRiskmap from './risk-riskmap/risk-riskmap.reducer';
import { RiskRiskmapEffects } from "./risk-riskmap/risk-riskmap.effects";
import * as fromRiskEvaluation from './risk-evaluation/risk-evaluation.reducer';
import { RiskEvaluationEffects } from "./risk-evaluation/risk-evaluation.effects";
import * as fromMassiveEditEvaluation from './massive-edit-evaluation/massive-edit-evaluation.reducer';
import { MassiveEditEvaluationEffects } from "./massive-edit-evaluation/massive-edit-evaluation.effects";
import * as fromProcessEvaluation from './process-evaluation/process-evaluation.reducer';
import { ProcessEvaluationEffects } from "./process-evaluation/process-evaluation.effects";
import * as fromPlanningPanel from './planning-panel/planning-panel.reducer';
import { PlanningPanelEffects } from "./planning-panel/planning-panel.effects";
import * as fromProcessCoverage from './process-coverage/process-coverage.reducer';
import * as fromLookupProposal from './proposal/proposal.reducer';
import * as fromMassiveEditQualitative from './massive-edit-qualitative/massive-edit-qualitative.reducer';
import { MassiveEditQualitativeEffects } from "./massive-edit-qualitative/massive-edit-qualitative.effects";
import { ProcessCoverageEffects } from "./process-coverage/process-coverage.effects";
import { LookupProposalEffects } from "./proposal/proposal.effects";
import * as fromAuditPlans from './audit-plans/audit-plans.reducer';
import * as fromHistoryLog from './history-log/history-log.reducer';
import * as fromHistoryLogEvaluation from './history-log-evaluation/history-log-evaluation.reducer';
import { AuditPlansEffects } from "./audit-plans/audit-plans.effects";
import * as fromSelfDashboard from './self-dashboard/self-dashboard.reducer';
import { SelfDashboardEffects } from "./self-dashboard/self-dashboard.effects";
import * as fromOrgIndependence from './org-independence/org-independence.reducer';
import { OrgIndependenceEffects } from "./org-independence/org-independence.effects";
import * as fromConfermanceGias from './confermance-gias/confermance-gias.reducer';
import { ConfermanceGiasEffects } from "./confermance-gias/confermance-gias.effects";
import * as fromManageStandards from './manage-standards/manage-standards.reducer';
import { ManageStandardsEffects } from "./manage-standards/manage-standards.effects";
import * as fromGiasAssessment from './gias-assessment/gias-assessment.reducer';
import { GiasAssessmentEffects } from "./gias-assessment/gias-assessment.effects";
import { HistoryLogEffects } from "./history-log/history-log.effects";
import { HistoryLogEvaluationEffects } from "./history-log-evaluation/history-log-evaluation.effects";
import * as fromHistoryLogBaseline from './history-log-baseline/history-log-baseline.reducer';
import { HistoryLogBaselineEffects } from "./history-log-baseline/history-log-baseline.effects";
import * as fromHistoryLogQualitative from './history-log-qualitative/history-log-qualitative.reducer';
import { HistoryLogQualitativeEffects } from "./history-log-qualitative/history-log-qualitative.effects";
import * as fromHistoryLogRelevance from './history-log-relevance/history-log-relevance.reducer';
import { HistoryLogRelevanceEffects } from "./history-log-relevance/history-log-relevance.effects";
import * as fromManageCampaignConfermanceGias from './manage-campaign-confermance-gias/manage-campaign-confermance-gias.reducer';
import { ManageCampaignConfermanceGiasEffects } from "./manage-campaign-confermance-gias/manage-campaign-confermance-gias.effects";
import * as fromSummary from './summary/summary.reducer';
import { SummaryEffects } from "./summary/summary.effects";
import * as fromKirs from './kirs/kirs.reducer';
import { KirsEffects } from "./kirs/kirs.effects";
import * as fromManageCampaignsKirs from './manage-campaigns-kirs/manage-campaigns-kirs.reducer';
import * as fromManageKirs from './manage-kirs/manage-kirs.reducer';
import * as fromKirsAssessment from './kirs-assessment/kirs-assessment.reducer';
import { KirsAssessmentEffects } from "./kirs-assessment/kirs-assessment.effects";
import { ManageKirsEffects } from "./manage-kirs/manage-kirs.effects";
import { ManageCampaignsKirsEffects } from "./manage-campaigns-kirs/manage-campaigns-kirs.effects";
import * as fromKirsSummary from './kirs-summary/kirs-summary.reducer';
import { KirsSummaryEffects } from "./kirs-summary/kirs-summary.effects";
import * as fromMassiveEditConformanceGias from './massive-edit-conformance-gias/massive-edit-conformance-gias.reducer';
import { MassiveEditConformanceGiasEffects } from "./massive-edit-conformance-gias/massive-edit-conformance-gias.effects";
import * as fromMassiveEditKirs from './massive-edit-kirs/massive-edit-kirs.reducer';
import { MassiveEditKirsEffects } from "./massive-edit-kirs/massive-edit-kirs.effects";
import * as fromTimeStampTable from './time-stamp-table/time-stamp-table.reducer';
import { TimeStampTableEffects } from "./time-stamp-table/time-stamp-table.effects";
import * as fromCapacityPlanning from './capacity-planning/capacity-planning.reducer';
import { CapacityPlanningEffects } from "./capacity-planning/capacity-planning.effects";
import * as fromActivityValueChain from './activity-value-chain/activity-value-chain.reducer';
import { ActivityValueChainEffects } from "./activity-value-chain/activity-value-chain.effects";
import * as fromCapacityPlanningInput from './capacity-planning-input/capacity-planning-input.reducer';
import { CapacityPlanningInputEffects } from "./capacity-planning-input/capacity-planning-input.effects";
import * as fromActivityPlnningInput from './activity-planning-input/activity-planning-input.reducer';
import { ActivityPlanningInputEffects } from "./activity-planning-input/activity-planning-input.effects";
import { modulePermissionsFeature } from './module-permissions/module-permissions.reducer';
import { ModulePermissionsEffects } from './module-permissions/module-permissions.effects';

export const stateFeatureKey = "state";

export interface State {
  [fromAdministration.administrationsFeatureKey]: fromAdministration.State;
  [fromScenario.scenariosFeatureKey]: fromScenario.State;
  [fromLegalEntities.legalEntitiesFeatureKey]: fromLegalEntities.State;
  [fromCpt.cptsFeatureKey]: fromCpt.State;
  [fromUsers.usersesFeatureKey]: fromUsers.State;
  [fromRisks.risksFeatureKey]: fromRisks.State;
  [fromQualitative.qualitativeFeaturesKey]: fromQualitative.State;
  [fromRiskMap.riskMapsFeatureKey]: fromRiskMap.State;
  [fromDataMonitoring.dataMonitoringsFeatureKey]: fromDataMonitoring.State;
  [fromEvaluation.evaluationsFeatureKey]: fromEvaluation.State;
  [fromRelevance.relevanceFeatureKey]: fromRelevance.State;
  [fromQualitativeInput.qualitativeInputsFeatureKey]: fromQualitativeInput.State;
  [fromBaselineCheck.baselineChecksFeatureKey]: fromBaselineCheck.State;
  [fromHeatmap.heatmapFeatureKey]: fromHeatmap.State;
  [fromThreshold.thresholdFeatureKey]: fromThreshold.State;
  [fromStandardRiskmap.standardRiskmapsFeatureKey]: fromStandardRiskmap.State;
  [fromRiskmaptree.riskmaptreesFeatureKey]: fromRiskmaptree.State;
  [fromRiskMapProcessFeatureKey.riskMapProcessFeatureKey]: fromRiskMapProcessFeatureKey.State;
  [fromEvaluationTree.evaluationTreesFeatureKey]: fromEvaluationTree.State;
  [fromRelevanceTree.relevanceTreeFeatureKey]: fromRelevanceTree.State;
  [fromBaselineCheckTree.baselineCheckTreesFeatureKey]: fromBaselineCheckTree.State;
  [fromStandardRelevance.standardRelevancesFeatureKey]: fromStandardRelevance.State;
  [fromCampaignDashboard.campaignDashboardsFeatureKey]: fromCampaignDashboard.State;
  [fromIcsEvaluation.icsEvaluationsFeatureKey]: fromIcsEvaluation.State;
  [fromIcsAttestation.icsAttestationsFeatureKey]: fromIcsAttestation.State;
  [fromManageCampaign.manageCampaignsFeatureKey]: fromManageCampaign.State;
  [fromScenarioConfiguration.scenarioConfigurationsFeatureKey]: fromScenarioConfiguration.State;
  [fromScenarioConsolidation.scenarioConsolidationsFeatureKey]: fromScenarioConsolidation.State;
  [fromIcsEvaluation.icsEvaluationsFeatureKey]: fromIcsEvaluation.State;
  [fromProcessRiskmap.processRiskmapsFeatureKey]: fromProcessRiskmap.State;
  [fromRiskRiskmap.riskRiskmapsFeatureKey]: fromRiskRiskmap.State;
  [fromRiskEvaluation.riskEvaluationsFeatureKey]: fromRiskEvaluation.State;
  [fromMassiveEditEvaluation.massiveEditEvaluationsFeatureKey]: fromMassiveEditEvaluation.State;
  [fromProcessEvaluation.processEvaluationsFeatureKey]: fromProcessEvaluation.State;
  [fromPlanning.planningsFeatureKey]: fromPlanning.State;
  [fromPlanningPanel.planningPanelsFeatureKey]: fromPlanningPanel.State;
  [fromProcessCoverage.processCoveragesFeatureKey]: fromProcessCoverage.State;
  [fromLookupProposal.lookupProposalsFeatureKey]: fromLookupProposal.State;
  [fromMassiveEditQualitative.massiveEditQualitativesFeatureKey]: fromMassiveEditQualitative.State;
  [fromAuditPlans.auditPlansesFeatureKey]: fromAuditPlans.State;
  [fromSelfDashboard.selfDashboardsFeatureKey]: fromSelfDashboard.State;
  [fromOrgIndependence.orgIndependencesFeatureKey]: fromOrgIndependence.State;
  [fromConfermanceGias.confermanceGiasesFeatureKey]: fromConfermanceGias.State;
  [fromManageStandards.manageStandardsesFeatureKey]: fromManageStandards.State;
  [fromGiasAssessment.giasAssessmentsFeatureKey]: fromGiasAssessment.State;

  [fromHistoryLog.historyLogFeatureKey]: fromHistoryLog.State;
  [fromHistoryLogEvaluation.historyLogEvaluationFeatureKey]: fromHistoryLogEvaluation.State;
  [fromHistoryLogBaseline.historyLogBaselinesFeatureKey]: fromHistoryLogBaseline.State;
  [fromHistoryLogQualitative.historyLogQualitativesFeatureKey]: fromHistoryLogQualitative.State;
  [fromHistoryLogRelevance.historyLogRelevancesFeatureKey]: fromHistoryLogRelevance.State;
  [fromManageCampaignConfermanceGias.manageCampaignConfermanceGiasesFeatureKey]: fromManageCampaignConfermanceGias.State;
  [fromSummary.summariesFeatureKey]: fromSummary.State;
  [fromKirs.kirsesFeatureKey]: fromKirs.State;
  [fromManageCampaignsKirs.manageCampaignsKirsesFeatureKey]: fromManageCampaignsKirs.State;

  [fromManageKirs.manageKirsesFeatureKey]: fromManageKirs.State;
  [fromKirsAssessment.kirsAssessmentsFeatureKey]: fromKirsAssessment.State;
  [fromKirsSummary.kirsSummariesFeatureKey]: fromKirsSummary.State;
  [fromMassiveEditConformanceGias.massiveEditConformanceGiasesFeatureKey]: fromMassiveEditConformanceGias.State;
  [fromMassiveEditKirs.massiveEditKirsesFeatureKey]: fromMassiveEditKirs.State;
  [fromTimeStampTable.timeStampTablesFeatureKey]: fromTimeStampTable.State;
  [fromCapacityPlanning.capacityPlanningsFeatureKey]: fromCapacityPlanning.State;
  [fromActivityValueChain.activityValueChainsFeatureKey]: fromActivityValueChain.State;
  [fromCapacityPlanningInput.capacityPlanningInputsFeatureKey]: fromCapacityPlanningInput.State;
  [fromActivityPlnningInput.activityPlnningInputsFeatureKey]: fromActivityPlnningInput.State;
  modulePermissions: ReturnType<typeof modulePermissionsFeature.reducer>;

}

export const reducers: ActionReducerMap<State> = {
  [fromAdministration.administrationsFeatureKey]: fromAdministration.reducer,
  [fromScenario.scenariosFeatureKey]: fromScenario.reducer,
  [fromLegalEntities.legalEntitiesFeatureKey]: fromLegalEntities.reducer,
  [fromCpt.cptsFeatureKey]: fromCpt.reducer,
  [fromUsers.usersesFeatureKey]: fromUsers.reducer,
  [fromRisks.risksFeatureKey]: fromRisks.reducer,
  [fromQualitative.qualitativeFeaturesKey]: fromQualitative.reducer,
  [fromRiskMap.riskMapsFeatureKey]: fromRiskMap.reducer,
  [fromDataMonitoring.dataMonitoringsFeatureKey]: fromDataMonitoring.reducer,
  [fromEvaluation.evaluationsFeatureKey]: fromEvaluation.reducer,
  [fromRelevance.relevanceFeatureKey]: fromRelevance.reducer,
  [fromQualitativeInput.qualitativeInputsFeatureKey]: fromQualitativeInput.reducer,
  [fromBaselineCheck.baselineChecksFeatureKey]: fromBaselineCheck.reducer,
  [fromHeatmap.heatmapFeatureKey]: fromHeatmap.reducer,
  [fromThreshold.thresholdFeatureKey]: fromThreshold.reducer,
  [fromStandardRiskmap.standardRiskmapsFeatureKey]: fromStandardRiskmap.reducer,
  [fromRiskmaptree.riskmaptreesFeatureKey]: fromRiskmaptree.reducer,
  [fromRiskMapProcessFeatureKey.riskMapProcessFeatureKey]: fromRiskMapProcessFeatureKey.reducer,
  [fromEvaluationTree.evaluationTreesFeatureKey]: fromEvaluationTree.reducer,
  [fromRelevanceTree.relevanceTreeFeatureKey]: fromRelevanceTree.reducer,
  [fromBaselineCheckTree.baselineCheckTreesFeatureKey]: fromBaselineCheckTree.reducer,
  [fromStandardRelevance.standardRelevancesFeatureKey]: fromStandardRelevance.reducer,
  [fromCampaignDashboard.campaignDashboardsFeatureKey]: fromCampaignDashboard.reducer,
  [fromIcsEvaluation.icsEvaluationsFeatureKey]: fromIcsEvaluation.reducer,
  [fromIcsAttestation.icsAttestationsFeatureKey]: fromIcsAttestation.reducer,
  [fromManageCampaign.manageCampaignsFeatureKey]: fromManageCampaign.reducer,
  [fromProcessRiskmap.processRiskmapsFeatureKey]: fromProcessRiskmap.reducer,
  [fromRiskRiskmap.riskRiskmapsFeatureKey]: fromRiskRiskmap.reducer,
  [fromRiskEvaluation.riskEvaluationsFeatureKey]: fromRiskEvaluation.reducer,
  [fromMassiveEditEvaluation.massiveEditEvaluationsFeatureKey]: fromMassiveEditEvaluation.reducer,
  [fromProcessEvaluation.processEvaluationsFeatureKey]: fromProcessEvaluation.reducer,
  [fromPlanning.planningsFeatureKey]: fromPlanning.reducer,
  [fromPlanningPanel.planningPanelsFeatureKey]: fromPlanningPanel.reducer,
  [fromProcessCoverage.processCoveragesFeatureKey]: fromProcessCoverage.reducer,
  [fromLookupProposal.lookupProposalsFeatureKey]: fromLookupProposal.reducer,
  [fromMassiveEditQualitative.massiveEditQualitativesFeatureKey]: fromMassiveEditQualitative.reducer,
  [fromAuditPlans.auditPlansesFeatureKey]: fromAuditPlans.reducer,
  [fromScenarioConfiguration.scenarioConfigurationsFeatureKey]: fromScenarioConfiguration.reducer,
  [fromScenarioConsolidation.scenarioConsolidationsFeatureKey]: fromScenarioConsolidation.reducer,
  [fromSelfDashboard.selfDashboardsFeatureKey]: fromSelfDashboard.reducer,
  [fromOrgIndependence.orgIndependencesFeatureKey]: fromOrgIndependence.reducer,
  [fromConfermanceGias.confermanceGiasesFeatureKey]: fromConfermanceGias.reducer,
  [fromManageStandards.manageStandardsesFeatureKey]: fromManageStandards.reducer,
  [fromGiasAssessment.giasAssessmentsFeatureKey]: fromGiasAssessment.reducer,
  [fromHistoryLog.historyLogFeatureKey]: fromHistoryLog.reducer,
  [fromHistoryLogEvaluation.historyLogEvaluationFeatureKey]: fromHistoryLogEvaluation.reducer,
  [fromHistoryLogBaseline.historyLogBaselinesFeatureKey]: fromHistoryLogBaseline.reducer,
  [fromHistoryLogQualitative.historyLogQualitativesFeatureKey]: fromHistoryLogQualitative.reducer,
  [fromHistoryLogRelevance.historyLogRelevancesFeatureKey]: fromHistoryLogRelevance.reducer,
  [fromManageCampaignConfermanceGias.manageCampaignConfermanceGiasesFeatureKey]: fromManageCampaignConfermanceGias.reducer,
  [fromSummary.summariesFeatureKey]: fromSummary.reducer,
  [fromKirs.kirsesFeatureKey]: fromKirs.reducer,
  [fromManageCampaignsKirs.manageCampaignsKirsesFeatureKey]: fromManageCampaignsKirs.reducer,
  [fromManageKirs.manageKirsesFeatureKey]: fromManageKirs.reducer,
  [fromKirsAssessment.kirsAssessmentsFeatureKey]: fromKirsAssessment.reducer,
  [fromKirsSummary.kirsSummariesFeatureKey]: fromKirsSummary.reducer,
  [fromMassiveEditConformanceGias.massiveEditConformanceGiasesFeatureKey]: fromMassiveEditConformanceGias.reducer,
  [fromMassiveEditKirs.massiveEditKirsesFeatureKey]: fromMassiveEditKirs.reducer,
  [fromTimeStampTable.timeStampTablesFeatureKey]: fromTimeStampTable.reducer,
  [fromCapacityPlanning.capacityPlanningsFeatureKey]: fromCapacityPlanning.reducer,
  [fromActivityValueChain.activityValueChainsFeatureKey]: fromActivityValueChain.reducer,
  [fromCapacityPlanningInput.capacityPlanningInputsFeatureKey]: fromCapacityPlanningInput.reducer,
  [fromActivityPlnningInput.activityPlnningInputsFeatureKey]: fromActivityPlnningInput.reducer,
  modulePermissions: modulePermissionsFeature.reducer,
};

export const userMetaReducer = (
  reducer: ActionReducer<State>
): ActionReducer<State> => {
  return (state, action) => {
    switch (action.type) {
      case INIT:
        const storageValue = localStorage.getItem("state");
        if (storageValue) {
          try {
            localStorage.setItem("selectedScope", JSON.parse(storageValue)['riskMaps']['selectedScopes'])
            localStorage.setItem("selectedScope", JSON.parse(storageValue)?.['processRiskmaps']?.['selectedScopes'])
            localStorage.setItem("level", JSON.parse(storageValue)['riskMaps']['level'])
            localStorage.setItem("optionList", JSON.parse(storageValue)['riskMaps']['optionLists'])
            localStorage.setItem("view", JSON.parse(storageValue)['riskMaps']['view'])
            localStorage.removeItem("state");
            return JSON.parse(storageValue);
          } catch {
            localStorage.setItem("selectedScope", JSON.parse(storageValue)['riskMaps']['selectedScopes'])
            localStorage.setItem("selectedScope", JSON.parse(storageValue)?.['processRiskmaps']?.['selectedScopes'])
            localStorage.setItem("level", JSON.parse(storageValue)['riskMaps']['level'])
            localStorage.setItem("optionList", JSON.parse(storageValue)['riskMaps']['optionLists'])
            localStorage.setItem("view", JSON.parse(storageValue)['riskMaps']['view'])
            localStorage.removeItem("state");
          }
        }
        break;
      case AdministrationActions.refresh().type: {
        console.log("Saving element...")
        const savedState = reducer(state, action);
        localStorage.setItem("state", JSON.stringify(savedState));
        break;
      }
    }
    const nextState = reducer(state, action);
    return nextState;
  }
}
export const metaReducers: MetaReducer<State>[] = [
  userMetaReducer
];

export const effects = [
  AdministrationEffects,
  ScenarioEffects,
  LegalEntitiesEffects,
  CptEffects,
  UserEffects,
  RiskEffects,
  QualitativeEffects,
  RiskMapEffects,
  DataMonitoringEffects,
  EvaluationEffects,
  RelevanceEffects,
  QualitativeInputEffects,
  BaselineCheckEffects,
  HeatmapEffects,
  ThresholdEffects,
  StandardRiskmapEffects,
  RiskmaptreeEffects,
  QualitativeInputTreeEffects,
  EvaluationTreeEffects,
  RelevanceTreeEffects,
  BaselineCheckTreeEffects,
  StandardRelevanceEffects,
  CampaignDashboardEffects,
  IcsEvaluationEffects,
  IcsAttestationEffects,
  ManageCampaignEffects,
  ProcessRiskmapEffects,
  RiskRiskmapEffects,
  RiskEvaluationEffects,
  MassiveEditEvaluationEffects,
  ProcessEvaluationEffects,
  ScenarioConfigurationEffects,
  ScenarioConsolidationEffects,
  MassiveEditQualitativeEffects,
  ProcessCoverageEffects,
  LookupProposalEffects,
  PlanningPanelEffects,
  AuditPlansEffects,
  SelfDashboardEffects,
  OrgIndependenceEffects,
  ConfermanceGiasEffects,
  ManageStandardsEffects,
  GiasAssessmentEffects,
  HistoryLogEffects,
  HistoryLogEvaluationEffects,
  HistoryLogBaselineEffects,
  HistoryLogQualitativeEffects,
  HistoryLogRelevanceEffects,
  ManageCampaignConfermanceGiasEffects,
  SummaryEffects,
  KirsEffects,
  KirsAssessmentEffects,
  ManageKirsEffects,
  ManageCampaignsKirsEffects,
  KirsSummaryEffects,
  MassiveEditConformanceGiasEffects,
  MassiveEditKirsEffects,
  TimeStampTableEffects,
  CapacityPlanningEffects,
  ActivityValueChainEffects,
  CapacityPlanningInputEffects,
  ActivityPlanningInputEffects,
  ModulePermissionsEffects,
];
